import { MutationTree } from "vuex";
import propertyDocumentTypesStore from "./property-document-types.store";
import { IPropertyEditState } from "../property-states.store";
import { IPropertyDocumentModel, PropertyDocumentUpdateModel, MoveGroupModel } from "../../../../models/property";
import { itemStateConstant } from "../../../../common";
import { AppSettingStored } from "../../../../utils/setting/app.setting";

const documentMutations: MutationTree<IPropertyEditState> = <MutationTree<IPropertyEditState>>{
	/**
	 * get list
	 */
	[propertyDocumentTypesStore.Set.LIST_OF_PROPERTY_DOCUMENTS]: (
		state: IPropertyEditState,
		listOfPropertyDocments: IPropertyDocumentModel[]
	) => {
		state.property.Documents = listOfPropertyDocments;
	},

	/**
	 * INSERT
	 */
	[propertyDocumentTypesStore.Set.INSERT_PROPERTY_DOCUMENTS]: (
		state: IPropertyEditState,
		listOfPropertyDocments: IPropertyDocumentModel[]
	) => {
		// get min id
        let minId = -1;
        if (!state.property.Documents) {
            state.property.Documents = [];
            state.originalProperty.Documents = []
        }
        if (state.property.Documents.length > 0) {
			let addedItems = state.property.Documents.filter(
				x => x.ItemState === itemStateConstant.Added
			);
			if (addedItems.length > 0) {
				minId = Math.min.apply(
					Math,
					addedItems.map(function (o) {
						return o.Id;
					})
				);
			}
		}

		// add item to list
		listOfPropertyDocments.forEach(x => {
			minId = minId - 1;

			x.ItemState = itemStateConstant.Added;
			x.Id = minId;
            state.property.Documents.push(x);
		});
	},

	/**
	 * INSERT NEW GROUP
	 */
	[propertyDocumentTypesStore.Set.INSERT_GROUP_PROPERTY_DOCUMENT]: (
		state: IPropertyEditState,
		listOfPropertyDocments: IPropertyDocumentModel[]
	) => {
		// get min id
		let minId = -1;
		if (state.property.Documents.length > 0) {
			let addedItems = state.property.Documents.filter(
				x => x.ItemState === itemStateConstant.Added
			);
			if (addedItems.length > 0) {
				// calculate min id
				minId = Math.min.apply(
					Math,
					addedItems.map(function (o) {
						return o.Id;
					})
				);
			}
		}

		// add item to list
		let groupIconUrl: string =
			AppSettingStored.instance().ResourceUrl +
			"/" +
			AppSettingStored.instance().GroupIconFilePath;

		listOfPropertyDocments.forEach(x => {
			minId = minId - 1;
			x.ItemState = itemStateConstant.Added;
			x.Id = minId;
			x.IconURL = groupIconUrl;
			state.property.Documents.push(x);
		});
	},

	/**
	 * UPDATED
	 */
	[propertyDocumentTypesStore.Set.UPDATE_PROPERTY_DOCUMENT]: (
		state: IPropertyEditState,
		updateModel: PropertyDocumentUpdateModel
	) => {
		var entity = state.property.Documents.find(c => c.Id == updateModel.Id);
		if (entity != undefined) {
			entity[updateModel.Field] = updateModel.Value;
			if (entity.ItemState != itemStateConstant.Added)
				entity.ItemState = itemStateConstant.Modified;
		}
	},

	/**
	 * DELETED
	 */
	[propertyDocumentTypesStore.Set.DELETE_PROPERTY_DOCUMENT]: (
		state: IPropertyEditState,
		id: number
	) => {
		// UPDATE ITEM IF THIS IS ITEM HAD BE STORED IN THE SERVICE
		// DELETE ITEM IF THIS IS ITEM HAD JUST ADDED
		let item = state.property.Documents.find(x => x.Id === id);
		if (item.ItemState === itemStateConstant.Added) {
			let index = state.property.Documents.indexOf(item);
			state.property.Documents.splice(index, 1);
		} else {
			item.ItemState = itemStateConstant.Deleted;
		}
	},

	/**
	 * MOVE GROUP
	 */
	[propertyDocumentTypesStore.Set.MOVE_GROUP_PROPERTY_DOCUMENT]: (
		state: IPropertyEditState,
		moveGroupModel: MoveGroupModel
	) => {
		// ignore if move to it self
		if (moveGroupModel.fromId == moveGroupModel.toId) return;

		// get item
		let fromItem = state.property.Documents.find(
			c => c.Id == moveGroupModel.fromId
		);
		let toItem = state.property.Documents.find(
			c => c.Id == moveGroupModel.toId
		);

		// HANDLE LOGIC
		// 1. IF TO ITEM IS FOLDER
		// => SET FROM ITEM IS CHILD OF THIS FOLDER
		// BY SET GROUPID  = PARENT ID

		if (fromItem != null && toItem != null) {
			// ignore move to file
			if (toItem.DocumentTypeId > 0) return;
			// ignore move to root
			if (toItem.DocumentTypeId < 0) return;
			// ignore move to old parent
			if (toItem.Id == fromItem.GroupId) return;
			// ignore move from parent to child
			if (toItem.GroupId == fromItem.Id) return;
			fromItem.GroupId = toItem.Id;
			if (fromItem.ItemState != itemStateConstant.Added)
				fromItem.ItemState = itemStateConstant.Modified;
		}
	}
};

export default documentMutations;
